import React, { useState, useEffect, useMemo, memo } from "react";
import { connect } from "react-redux";
import { Validation } from "../../helpers/validations";
import { errors, spanishErrors, states, Makes, Models } from "./constant";
import WrapperComponent from "../wrapperComponent";
import { AddParking, EditParking } from "../../redux/actions/parking";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const ParkingForm = memo(
  ({ loading, user = {}, closeModal, edit, item, AddParking, EditParking, parkingSpotList, vehicles = [], openParkingAlert, closeModalAdd }) => {
    const [error, setError] = useState({});
    const [formData, setFormData] = useState({ Model: "", Make: "", Year: "", Color: "", LicensePlate: "", state: "", spot: "" });
    const { t } = useTranslation();

    const takenSpots = useMemo(() => {
      const set = new Set();
      for (const v of vehicles) {
        if (v.isArchived) continue;
        if (!v.zzid_SPOT) continue;
        if (item?.zzID && v.zzID === item.zzID) continue;
        set.add(v.zzid_SPOT);
      }
      return set;
    }, [vehicles, item?.zzID]);

    useEffect(() => {
      if (item.zzID) {
        setFormData({
          Model: item.Model || "",
          Make: item.Make || "",
          Year: item.Year || "",
          Color: item.Color || "",
          LicensePlate: item.LicensePlate || "",
          state: item.RegisteredState || "",
          spot: item.zzid_SPOT || "",
        });
      }
    }, [item]);

    const handleChange = (e, name) => {
      if (name === "Year") {
        setFormData({ ...formData, [name]: e.target.value.replace(/[^0-9]/g, "").slice(0, 4) });
      } else {
        setFormData({ ...formData, [name]: e.target.value });
      }
    };

    const getModels = () => {
      return Models.filter((m) => m.make === formData.Make).map((ele) => ({
        value: ele.model,
        label: ele.model,
      }));
    };

    const handleValidation = (type) => {
      let lang = localStorage.getItem("i18nextLng") === "es";
      if (type === "Model") {
        if (!Validation.name(formData.Model)) {
          setError({ ...error, Model: lang ? spanishErrors.Model : errors.Model });
          return false;
        }
      } else if (type === "Make") {
        if (!Validation.name(formData.Make)) {
          setError({ ...error, Make: lang ? spanishErrors.Make : errors.Make });
          return false;
        }
      } else if (type === "Color") {
        if (!Validation.name(formData.Color)) {
          setError({ ...error, Color: lang ? spanishErrors.Color : errors.Color });
          return false;
        }
      } else if (type === "Year") {
        if (!Validation.year(formData.Year)) {
          setError({ ...error, Year: lang ? spanishErrors.Year : errors.Year });
          return false;
        }
      } else if (type === "LicensePlate") {
        if (!Validation.name(formData.LicensePlate)) {
          setError({ ...error, LicensePlate: lang ? spanishErrors.LicensePlate : errors.LicensePlate });
          return false;
        }
      } else if (type === "state") {
        if (!Validation.name(formData.state)) {
          setError({ ...error, state: lang ? spanishErrors.state : errors.state });
          return false;
        }
      }
      return true;
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      const fields = ["Make", "Model", "Year", "Color", "LicensePlate", "state", "spot"];
      let isvalid = false;
      for (let i = 0; i < fields.length; i++) {
        isvalid = handleValidation(fields[i]);
        if (!isvalid) break;
      }
      if (!isvalid) return;
      const { Color, state, Year, LicensePlate, Make, Model, spot } = formData;
      const payload = {
        Color,
        RegisteredState: state,
        Year,
        LicensePlate,
        Make,
        Model,
        zzid_SPOT: spot || undefined,
        zzModifiedByWeb: !edit ? user.Email_01 : undefined,
      };
      if (edit) {
        EditParking(item.zzID, payload, closeModal);
      } else {
        AddParking(payload, closeModalAdd);
      }
    };

    return (
      <section className="parkingform-container">
        <div className="form-group m-b-10">
          <Select
            isDisabled={edit}
            className={`${error.Make && "is-invalid"}`}
            placeholder="Select Make"
            options={Makes.map(({ make }) => ({ value: make, label: make }))}
            value={{
              value: formData.Make || "",
              label: formData.Make || "Select Make",
            }}
            onChange={(selectedOption) =>
              setFormData({ ...formData, Make: selectedOption.value, Model: "" })
            }
            onBlur={() => handleValidation("Make")}
            onFocus={() => setError({ ...error, Make: "" })}
          />
          <h5 className="invalid-feedback">{error.Make}</h5>
        </div>

        <div className="form-group m-b-10">
          <Select
            isDisabled={edit}
            className={`${error.Model && "is-invalid"}`}
            options={getModels()}
            placeholder="Select Model"
            onChange={(selectedOption) =>
              setFormData({ ...formData, Model: selectedOption.value })
            }
            value={{
              value: formData.Model || "",
              label: formData.Model || "Select Model",
            }}
            onBlur={() => handleValidation("Model")}
            onFocus={() => setError({ ...error, Model: "" })}
          />
          <h5 className="invalid-feedback">{error.Model}</h5>
        </div>

        <div className="form-group m-b-10">
          <input
            type="text"
            className={`form-control form-control-lg ${error.Year && "is-invalid"}`}
            disabled={edit}
            placeholder="Year"
            value={formData.Year}
            onChange={(e) => handleChange(e, "Year")}
            onBlur={() => handleValidation("Year")}
            onFocus={() => setError({ ...error, Year: "" })}
          />
          <h5 className="invalid-feedback">{error.Year}</h5>
        </div>

        <div className="form-group m-b-10">
          <input
            type="text"
            className={`form-control form-control-lg ${error.Color && "is-invalid"}`}
            disabled={edit}
            placeholder="Color"
            value={formData.Color}
            onChange={(e) => handleChange(e, "Color")}
            onBlur={() => handleValidation("Color")}
            onFocus={() => setError({ ...error, Color: "" })}
          />
          <h5 className="invalid-feedback">{error.Color}</h5>
        </div>

        <div className="form-group m-b-10">
          <input
            type="text"
            className={`form-control form-control-lg ${error.LicensePlate && "is-invalid"}`}
            disabled={edit}
            placeholder="LicensePlate Number"
            value={formData.LicensePlate}
            onChange={(e) => handleChange(e, "LicensePlate")}
            onBlur={() => handleValidation("LicensePlate")}
            onFocus={() => setError({ ...error, LicensePlate: "" })}
          />
          <h5 className="invalid-feedback">{error.LicensePlate}</h5>
        </div>

        <div className="form-group m-b-10">
          <select
            className={`form-control form-control-lg ${error.state && "border border-danger"}`}
            disabled={edit}
            value={formData.state || ""}
            onChange={(e) => handleChange(e, "state")}
            onBlur={() => handleValidation("state")}
            onFocus={() => setError({ ...error, state: "" })}
          >
            <option value="">Select State</option>
            {states.map((s, i) => (
              <option key={i} value={s.Code}>{s.State}</option>
            ))}
          </select>
          <h5 className="invalid-feedback">{error.state}</h5>
        </div>
        {parkingSpotList?.length > 0 && (
          <div className="form-group m-b-10">
            <select
              className={`form-control form-control-lg m-t-10 ${error.spot && "border border-danger"}`}
              value={formData.spot}
              onChange={(e) => handleChange(e, "spot")}
              onBlur={() => handleValidation("spot")}
              onFocus={() => setError({ ...error, spot: "" })}
            >
              <option value="">Select Spot</option>
              {parkingSpotList.map((s, i) => {
                const taken = takenSpots.has(s.spotZzID);
                const isCurrent = !!item?.zzid_SPOT && s.spotZzID === item.zzid_SPOT;
                const label = taken
                  ? "(In use)"
                  : isCurrent
                  ? "(Current)"
                  : "(Unassigned)";
                return (
                  <option
                    disabled={taken}
                    style={taken ? { color: "grey" } : { color: "black" }}
                    key={i}
                    value={s.spotZzID}
                  >
                    {`${s.spotNumber ?? ""} ${label}`}
                  </option>
                );
              })}
            </select>
            <h5 className="invalid-feedback">{error.spot}</h5>
          </div>
        )}

        {edit && !item.isArchived && (
          <button
            className="btn btn-sm btn-default"
            onClick={openParkingAlert}
          >
            {t("modal.parking.archive")}
          </button>
        )}

        <button
          type="submit"
          disabled={loading}
          className="btn btn-warning btn-block m-t-10"
          onClick={handleSubmit}
        >
          {!loading ? t("modal.parking.submit") : <i className="fas fa-spinner fa-pulse"></i>}
        </button>
      </section>
    );
  }
);

const mapStateToProps = ({ PARKING_REDUCER, USER_REDUCER }) => {
  return {
    loading: PARKING_REDUCER.loading,
    user: USER_REDUCER.userData,
    parkingSpotList: PARKING_REDUCER.spots,
    vehicles: PARKING_REDUCER.vehicles,
  };
};

const ParkingWrapper = (props) => (
  <WrapperComponent>
    <ParkingForm {...props} />
  </WrapperComponent>
);
export default connect(mapStateToProps, {
  AddParking,
  EditParking,
})(ParkingWrapper);
